module.exports = __webpack_public_path__ + "static/media/Glazbeno-scenki prikaz-foto 5.d3c2ed5d.jpg";